<template>
    <div class="overview-nav custom-contract">
        <div class="toggle-bar">
            <div class="icon">
                <SvgIcon icon="toggle"/>
            </div>
        </div>
        <div class="heading">
            <h1>{{ $t('custom-contract.sidebar.headline') }}</h1>
            <p>{{ addressLine1 }} <br/>{{ property.zip_code }} {{ property.city }}</p>
        </div>
        <div class="create-bottom">
            <div class="content">
                <div class="double-buttons">
                    <button
                        @click="goToPrevTab()"
                        class="transparent"
                        :disabled="state === 'saving' || !this.customContract.id || this.activeTabHash === '#customContractPageSelectTab'">
                        <SvgIcon icon="button-prev"/>
                        {{ $t('digital.previousstep') }}
                    </button>
                    <button
                        @click="goToNextTab()"
                        class="transparent"
                        :disabled="state === 'saving' || !this.customContract.id || this.activeTabHash === '#customContractReviewAndSendTab'"
                    >
                        {{ $t('digital.tabs.nextstep') }}
                        <SvgIcon icon="button-next"/>
                    </button>
                </div>

                <div class="button-container">
                    <button @click="$emit('preview')" class="transparent"
                            :disabled="state === 'saving' || !this.customContract.id">
                        <span>{{ $t('digital.tabs.review.preview') }}</span>
                    </button>

                    <button @click="$emit('save')" class="transparent"
                            :disabled="saveDisabled">
                        <span v-if="state === 'saving'">{{ $t('digital.approvecontract.loading') }}</span>
                        <span v-else>{{ $t('button.save.label') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import SvgIcon from '../../../components/Svg.vue';

const tabOrder = [
    '#customContractUploadTab',
    '#customContractPageSelectTab',
    '#customContractLandlordTab',
    '#customContractTenantTab',
    '#customContractReviewAndSendTab'
];

export default {
    name: "CustomContractSidebar",
    props: ['state', 'customContract', 'customContractPage', 'property'],
    components: {
        SvgIcon
    },
    data() {
        return {
            activeTabHash: null
        }
    },
    computed: {
        saveDisabled() {
            return this.state === 'saving' || !this.customContract.id || this.activeTabHash === '#customContractReviewAndSendTab';
        },
        addressLine1() {
            var address1 = this.property.address ? this.property.address.replace(this.property.zip_code, '').replace(this.property.city, '') : '';
            if (address1) {
                return address1;
            }
            return 'no address';
        }
    },
    methods: {
        // Tab navigation next
        goToNextTab() {
            if (!this.customContract.id) {
                return;
            }

            let currentTabIndex = tabOrder.indexOf(this.activeTabHash)
            if (currentTabIndex < tabOrder.length)
                this.$parent.$refs.customContractTabs.selectTab(tabOrder[++currentTabIndex]);
            this.updateGreenMarks();
        },

        // Tab navigation prev
        goToPrevTab() {
            if (!this.customContract.id) {
                return;
            }

            let currentTabIndex = tabOrder.indexOf(this.activeTabHash)
            if (currentTabIndex > 0)
                this.$parent.$refs.customContractTabs.selectTab(tabOrder[--currentTabIndex]);
            this.updateGreenMarks();
        },

        // Mark completed tabs with green mark

        updateGreenMarks() {

            this.$nextTick(() => {

                if (_.findIndex(this.customContract.custom_contract_pages, {has_signatures: true}) !== -1) {
                    $('a[href="#customContractPageSelectTab"]').parent().addClass('is-filled');
                }

                if (_.isString(this.customContract.landlord_email)) {
                    $('a[href="#customContractLandlordTab"]').parent().addClass('is-filled');
                }

                if (this.customContract.tenants.length > 0) {
                    $('a[href="#customContractTenantTab"]').parent().addClass('is-filled');
                }

                this.activeTabHash = this.$parent.$refs.customContractTabs.activeTabHash;
            });

        }
    },
    watch: {
        customContract: function (value) {
            this.updateGreenMarks();
        },
        customContractPage: function () {
            this.updateGreenMarks();
        }
    },
    mounted() {
        this.updateGreenMarks();
    }

}
</script>

<style scoped>

</style>
